import React, { useEffect, useRef, useState } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import axiosInstance from "../../services/axiosService";
import { useTreeContext } from "../../context/TreeDataContext";
import Input from "../FormComponents/Input";
import MaterialIcon from "./MaterialIcon";
import { getTreeDataForStateMachine } from "../../utils/treeData/treeDataUtils";
// import useLocalStorage from "../../hooks/useLocalStorage";
// import { useParams } from "react-router-dom";

const FilterApplicationBlocks = ({ checkedBlocks, setCheckedBlocks, customStyles }) => {
  const [allUniqueTags, setAllUniqueTags] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const popupOptionDivRef = useRef();
  const [allSMs, setAllSMs] = useState([]);
  const [isAppUserChecked, setIsAppUserChecked] = useState(checkedBlocks.appUser || false);
  const [isRdbmsChecked, setIsRdbmsChecked] = useState(checkedBlocks.rdbms || false);
  // const {appId} = useParams()
  // const [checkedBlocks, setCheckedBlocks] = useLocalStorage("application_block_filters_"+appId, {
  //   table: [],
  //   tag: []
  // });

  const { stateMachineExplorerData, setStateMachineExplorerData } = useTreeContext();

  useClickOutside(popupOptionDivRef, () => setShowOptions(false));

  const handleCheckboxChange = (id, type) => {
    if (id === "clear_all") {
      setCheckedBlocks({
        ...checkedBlocks,
        [type]: []
      });
      return;
    }

    const updatedBlocks = checkedBlocks[type].includes(id)
      ? {
          ...checkedBlocks,
          [type]: checkedBlocks[type].filter((selectedBlock) => selectedBlock !== id)
        }
      : {
          ...checkedBlocks,
          [type]: [...checkedBlocks[type], id]
        };

    setCheckedBlocks(updatedBlocks);
  };

  const handleAppUserChange = (e) => {
    const isChecked = e.target.checked;
    setIsAppUserChecked(isChecked);
    setCheckedBlocks({
      ...checkedBlocks,
      appUser: isChecked
    });
  };

  const handleRdbmsChange = (e) => {
    const isChecked = e.target.checked;
    setIsRdbmsChecked(isChecked);
    setCheckedBlocks({
      ...checkedBlocks,
      rdbms: isChecked
    });
  };

  const fetchAllEntitiesandSM = async () => {
    const { data: smData } = await axiosInstance.get(`/state-machines`);
    const smTreeData = getTreeDataForStateMachine("all", smData);
    setStateMachineExplorerData(smTreeData);
    const namesArray = smTreeData.map((item) => item);
    setAllSMs(namesArray);
  };

  const fetchAllUniqueTags = async () => {
    const { data } = await axiosInstance.get(`/tag`);
    setAllUniqueTags(data);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (showOptions) {
        if (!stateMachineExplorerData) {
          await fetchAllEntitiesandSM();
        } else {
          const namesArray = stateMachineExplorerData.map((item) => item);
          setAllSMs(namesArray);
        }
        await fetchAllUniqueTags();
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOptions]);

  const data = [
    { title: "WF/Entity", type: "table", items: allSMs },
    { title: "Tags", type: "tag", items: allUniqueTags }
  ];
  const filterCount =
    checkedBlocks.table.length +
    checkedBlocks.tag.length +
    (checkedBlocks.appUser ? 1 : 0) +
    (checkedBlocks.rdbms ? 1 : 0);

  return (
    <div
      className="menu_container"
      onClick={() => {
        setShowOptions(!showOptions);
      }}
      ref={popupOptionDivRef}
    >
      <div className="filter_items">
        <MaterialIcon
          name="filter_alt"
          className="sidebar_icons"
          title="Filter Blocks"
          style={{ color: showOptions ? "var(--builder-primary)" : "var(--builder-icon-color)" }}
        />
        {filterCount > 0 && <span className="item_count">{filterCount}</span>}
      </div>
      {showOptions && (
        <div className="filter_blocks_outer" style={customStyles}>
          <CollapseFolders data={data} checkedBlocks={checkedBlocks} onChange={handleCheckboxChange} />

          <div className="popup_list_items justify_between" onClick={(e) => e.stopPropagation()}>
            <span className="filter_block_heading font_weight_medium" style={{ fontSize: "12px", fontWeight: "600" }}>
              App User
            </span>
            <div className="checkbox_list">
              <Input type="checkbox" id="app_user" checked={isAppUserChecked} onChange={handleAppUserChange} />
            </div>
          </div>

          <div className="popup_list_items justify_between" onClick={(e) => e.stopPropagation()}>
            <span className="filter_block_heading font_weight_medium" style={{ fontSize: "12px", fontWeight: "600" }}>
              RDBMS
            </span>
            <div className="checkbox_list">
              <Input type="checkbox" id="rdbms" checked={isRdbmsChecked} onChange={handleRdbmsChange} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterApplicationBlocks;

const CollapseFolders = ({ data, checkedBlocks, onChange }) => {
  const [collapsed, setCollapsed] = useState([]);

  useEffect(() => {
    setCollapsed(new Array(data.length).fill(false));
  }, [data]);

  const toggleCollapse = (e, index) => {
    e.stopPropagation();
    setCollapsed((prevState) => prevState.map((item, i) => (i === index ? !item : item)));
  };

  return (
    <div>
      {data.map((heading, index) => (
        <div key={index} className="mb_2">
          <div
            className="filter_block_heading cursor_pointer font_weight_medium"
            onClick={(e) => toggleCollapse(e, index)}
          >
            <MaterialIcon name={collapsed[index] ? "keyboard_arrow_right" : "keyboard_arrow_down"} />

            <span style={{ fontSize: "12px", fontWeight: "600" }}>
              {heading.title}({heading.items.length})
            </span>
            {checkedBlocks[heading.type]?.length > 0 && (
              <button
                className="clear_all_btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange("clear_all", heading.type); // we'll handle this in the `onChange` handler
                }}
                style={{
                  fontSize: "10px",
                  color: "#007bff",
                  textDecoration: "underline",
                  background: "none",
                  border: "none",
                  cursor: "pointer"
                }}
              >
                Clear All
              </button>
            )}
          </div>
          {!collapsed[index] && (
            <>
              {heading.items.map((subitem, subIndex) => (
                <div key={subIndex} className="popup_list_items justify_between" onClick={(e) => e.stopPropagation()}>
                  <span className="sidebar_filter_item">{subitem.name}</span>
                  <div className="checkbox_list">
                    <Input
                      type="checkbox"
                      id={subitem.id}
                      checked={checkedBlocks[heading.type].includes(subitem.id)}
                      onChange={() => onChange(subitem.id, heading.type)}
                    />
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  );
};
